import React from "react";

interface DummyProps {
    children: React.ReactElement | React.ReactElement[];
}

export const Dummy = (props: DummyProps) => {
    return <>{props.children}</>;
};
